const URL = require('@tencent/search-url');

function uigsClPb(e) {
  // 获取全局参数
  const { UIGS_PARA, __het, location } = window;
  if (!UIGS_PARA) return;
  const ev = e || window.event;
  let target = ev.target || ev.srcElement;
  const { className } = target;

  // 兼容vconsole报错
  if (className === 'vc-switch' || className === 'vc-mask') return;

  // 回到顶部return
  if (className === 'dt-gotop-arrow' || className === 'dt-gotop' || target.tagName === 'HTML') return;
  let uigsAttrVal = '';
  let uigsParamsVal = '';
  let level = 4;
  let href = '';

  while (target && level > 0) {
    const parent = target.parentNode;
    const tagName = target.tagName.toLowerCase();
    // 获取uigs属性
    uigsAttrVal = target.getAttribute('uigs');
    // 如果是a标签的话获取href属性进行参数拼接
    if (uigsAttrVal && target.nodeName.toLowerCase() === 'a') {
      uigsParamsVal = target.getAttribute('uigsparams');
      href = target.getAttribute('href') || '';
      const host = /^(?:http|https|qb):\/\//.test(href) ? '' : (location && location.origin) || '';
      const val = href === 'javascript:void(0);' ? 'javascript:void(0);' : `${host}/${href}`;
      href = !href ? '' : val;
    } else if (tagName === 'div' && target.className === 'dt-info-intro-more') {
      // detail模块展开折叠
      uigsAttrVal = 'detail_intro';
    } else if (tagName === 'div' && target.className === 'search-dt-playlist-wrap') {
      // 播单列表
      uigsAttrVal = 'search_related_bodan';
    }

    if (!uigsAttrVal) {
      if (parent === null || tagName === 'body') {
        break;
      }
      target = parent;
      level -= 1;
    } else {
      break;
    }
  }

  if (className === 'hhy-btn') {
    uigsAttrVal = 'searchbtn';
  }

  let rlevel = 8;
  let report;
  while (target && rlevel > 0) {
    report = target.dataset && target.dataset.report;
    if (report) {
      try {
        report = JSON.parse(report);
      } catch (e) {
        report = '';
      }
      break;
    } else {
      target = target.parentNode;
      rlevel -= 1;
    }
  }
  const clParams = {
    pbtype: 'cl',
    uigs_st: parseInt((new Date().getTime() - __het) / 1000, 10),
    uigs_cl: uigsAttrVal,
    href,
  };
  if (uigsParamsVal) {
    const obj = URL.parseQuery(uigsParamsVal);
    Object.keys(obj).forEach((key) => {
      clParams[key] = obj[key];
    });
  }

  const allParams = Object.assign({}, UIGS_PARA, clParams, report || {});
  const { play_url: playUrl, res_type: resType, uuid } = allParams;

  // NA点出，clickSessionId上报
  if ((playUrl && /^qb:\/\//.test(playUrl)) || resType === 'native') {
    allParams.clickSessionId = uuid ? `${uuid}_${Date.now()}` : '';
  }
  return allParams;
}

module.exports = { uigsClPb };
